const handleOutsideClick = (e, el, binding, vnode) => {
  e.stopPropagation();
  const { handler, exclude } = binding.value;
  let clickedOnExcludedEl = false;
  exclude.forEach(refName => {
    if (!clickedOnExcludedEl) {
      const excludedEl = vnode.context.$refs[refName];
      if (excludedEl) {
        clickedOnExcludedEl = excludedEl.contains(e.target);
      }
    }
  });
  if (!el.contains(e.target) && !clickedOnExcludedEl) {
    vnode.context[handler]();
  }
};

export default {
  bind(el, binding, vnode) {
    document.addEventListener("click", e =>
      handleOutsideClick(e, el, binding, vnode)
    );
    document.addEventListener("touchstart", e =>
      handleOutsideClick(e, el, binding, vnode)
    );
  },
  unbind(el, binding, vnode) {
    document.removeEventListener("click", e =>
      handleOutsideClick(e, el, binding, vnode)
    );
    document.removeEventListener("touchstart", e =>
      handleOutsideClick(e, el, binding, vnode)
    );
  }
};
